import { HttpBackend, HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TUI_ICON_RESOLVER } from '@taiga-ui/core';
import { catchError, Observable, of, shareReplay } from 'rxjs';

/**
 * Загружает SVG-иконки проекта (`x-icon::`, `x-icon-goods::`, `x-icon-lp::`) как текст
 * для inline-вставки. Запросы идут мимо HTTP-интерсепторов и кешируются на время сессии.
 */
@Injectable({
  providedIn: 'root',
})
export class SvgIconLoaderService {
  private readonly http = new HttpClient(inject(HttpBackend));
  private readonly resolve = inject(TUI_ICON_RESOLVER);
  private readonly cache = new Map<string, Observable<string>>();

  load(icon: string): Observable<string> {
    const url = this.resolve(icon);
    const cached = this.cache.get(url);

    if (cached) {
      return cached;
    }

    const request$ = this.http.get(url, { responseType: 'text' }).pipe(
      catchError(() => of('')),
      shareReplay(1),
    );

    this.cache.set(url, request$);

    return request$;
  }
}
